import clsx from 'clsx';
import React from 'react';
import validator from 'validator';
import { connect } from 'react-redux';
import scrollIntoView from 'scroll-into-view';
import { preventDefault, countDecimals, getFileMetaData } from '../../../../helper';
import { withStyles } from '@material-ui/core/styles';
import history from '../../../../../../routes/history';
import SnakBar from '../../../../../../components/SnakBar';
import PageHeader from '../../../../../../components/common/PageHeader';
import Icons from '../../../../../../containers/Permitting/Chats/images';
import uploadFileDetails from '../../../../../../utils/uploadFileDetails';
import CommentPopupBox from '../../../../../../components/Admin/Automation/Comment';
import { Box, Button, CircularProgress, Backdrop, Tooltip, TextField, Chip, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CommentDialog from '../../../../../../components/Admin/Automation/CommentDialog';
import { isEmpty, get, keysIn, hasIn, omit, isEqual, includes, round } from '../../../../../../utils/lodash';
import {
  getEquipment,
  createEquipment,
  getAllManufacturers,
  createEquipmentSuccess,
  getEquipmentModelValidation,
  deleteEquipmentUploadedFile,
  updateManufactureTags,
} from '../../../actions';
import {
  APPLICATION_STATE_TRANSITIONS,
  REJECT_DIALOG_WARNING,
  VIEW_ONLY_ROLES,
  MARK_AS_OUTDATED_HEADER,
} from '../../../../constants';
import BasicDetailsSection from '../../../../../../components/Admin/Automation/Equipment/BasicDetailsSection';
import RecordDetailsSection from '../../../../../../components/Admin/Automation/Equipment/RecordDetailsSection';
import ElectricalDetailsSection from '../../../../../../components/Admin/Automation/Equipment/Panel/DC/ElectricalDetailsSection';
import PhysicalDetailsSection from '../../../../../../components/Admin/Automation/Equipment/Panel/DC/PhysicalDetailsSection';

const styles = (theme) => ({
  root: {
    ...theme.mixins.gutters(),
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  backdrop: {
    zIndex: 11,
    color: theme.palette.primary.main,
  },
  btnStyle: { marginLeft: theme.spacing(0.5), color: 'white' },
});

class index extends React.Component {
  constructor(props) {
    super(props);
    this.autocomplete = null;
    this.event = null;
    this.commentDialogHeader = '';
    this.commentDialogSecondaryHeader = '';
    this.commentDialogAddSecondaryHeader = '';
    this.state = {
      id: 'new',
      isEquipmentUnique: true,
      isProductURLValid: true,
      manufacturersList: [],
      manufacturerTags: {
        enfin: [],
        goodleap: [],
        lightreach: [],
      },
      tags: {
        enfin: [],
        goodleap: [],
        lightreach: [],
      },
      basicDetails: {
        model: '',
        manufacturer: '',
        spec_sheet: [],
        prod_image: [],
        additional_document: [],
        spec_sheet_pages: '',
        product_url: '',
        created_by: '',
        modified_by: '',
        verified_by: '',
        created_at: '',
        modified_at: '',
        verified_at: '',
        source_model_name: '',
        source_series_name: '',
        warranty: '',
        country_codes: [],
        enfin_tags: [],
        goodleap_tags: [],
        lightreach_tags: [],
      },
      fileUploadLogs: {
        specSheet: {
          uploadError: {
            error: false,
            msg: '',
          },
          size: 0,
          uploadStatus: 'idle',
        },
        prodImage: {
          uploadError: {
            error: false,
            msg: '',
          },
          size: 0,
          uploadStatus: 'idle',
        },
        additionalDocument: {
          uploadError: {
            error: false,
            msg: '',
          },
          size: 0,
          uploadStatus: 'idle',
        },
      },
      electricalDetails: {
        max_power_rating_stc: '',
        max_power_rating_ptc: '',
        open_circuit_voltage: '',
        max_power_voltage: '',
        short_circuit_current: '',
        max_power_current: '',
        efficiency: '',
        energy_degradation: '0.5',
        voltage_temp_coefficient: '',
        voltage_temp_unit: '%/°C',
        current_temp_coefficient: '',
        current_temp_unit: '%/°C',
        power_temp_coefficient: '',
        power_temp_unit: '%/°C',
        nominal_operating_cell_temperature: '',
      },
      physicalDetailsUnit: 'metric',
      physicalDetails: {
        width: '',
        length: '',
        thickness: '',
        weight: '',
        cell_count: '',
        cell_type: 'mono',
        num_submodules: null,
        submodule_partition: null,
        black_on_black_panel: false,
      },
      currentStatus: '',
      errorData: {},
      comment: '',
      comments: [],
      openCommentDialog: false,
      recordSubmitted: false,
      readOnly: this.isReadOnly(),
    };
  }

  MAX_ALLOWED_FILE_SIZE = 53200;

  normalizeIncomingTags = (arr) => {
    if (!Array.isArray(arr)) return [];
    return Array.from(new Set(arr.map((v) => String(v ?? '').trim()).filter(Boolean)));
  };
  normalizeOutgoingTags = (arr) => {
    if (!Array.isArray(arr)) return [];
    return Array.from(new Set(arr.map((v) => String(v ?? '').trim()).filter(Boolean)));
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    const requestSource = 'dcpanel';
    if (id !== 'new')
      this.props.getEquipment({
        id,
        requestSource,
        successCB: (newEquipment) => {
          this.handleGetSuccessCallback(newEquipment);
        },
        failureCB: () => {
          this.handleCancel();
        },
      });
    if (isEmpty(this.state.manufacturersList)) {
      this.props.getAllManufacturers({
        successCb: () => {
          this.setState({ manufacturersList: this.props.manufacturersList });
        },
      });
    }
  }

  componentDidUpdate() {}

  componentWillUnmount() {}

  handleSubmit = async (applicationStatus) => {
    if (applicationStatus === 'OUTDATED') {
      this.event = applicationStatus;
      this.commentDialogHeader = this.getCommentDialog(applicationStatus).headerText;
      this.setState({ openCommentDialog: true });
      return;
    }

    await this.validateFields('all');
    const { errorData } = this.state;
    if (applicationStatus === 'EDIT') {
      return this.setState({ readOnly: false }, () => scrollIntoView(document.getElementById('model')));
    }
    if (applicationStatus === 'INCOMPLETE') {
      if (isEmpty(errorData)) {
        const payload = this.getPayload('INCOMPLETE');
        payload.successCB = (equipment, response) => {
          this.handleCancel();
          this.props.createEquipmentSuccess({ response });
          this.handleCreateSuccessCallback(equipment);
        };
        return this.props.createEquipment(payload);
      }
    }
    if (applicationStatus === 'PENDING') {
      this.setState({ recordSubmitted: true });
    }
    if (isEmpty(errorData)) {
      this.event = applicationStatus;
      this.commentDialogHeader = this.getCommentDialog(applicationStatus).headerText;
      this.commentDialogSecondaryHeader = this.getCommentDialog(applicationStatus).secondaryHeaderText;
      this.setState({ openCommentDialog: true });
    }
    const errorKeys = keysIn(errorData);
    scrollIntoView(document.getElementById(errorKeys.includes('model') ? 'model' : errorKeys[0]));
  };

  getCommentDialog = (applicationStatus) => {
    const commentDialog = {
      headerText: '',
      secondaryHeaderText: '',
    };
    const applicationStatusObject = APPLICATION_STATE_TRANSITIONS.find((state) => state.value === applicationStatus);
    commentDialog.headerText = applicationStatusObject.title;
    commentDialog.secondaryHeaderText = applicationStatusObject.key;
    return commentDialog;
  };

  handleProceed = () => {
    this.setState({ openCommentDialog: false }, () => {
      const payload = this.getPayload(this.event);
      payload.successCB = (equipment, response) => {
        this.updateManufactureTags(response);
        this.handleCancel();
        this.props.createEquipmentSuccess({ response });
        this.handleCreateSuccessCallback(equipment);
      };
      this.props.createEquipment(payload);
    });
  };
  updateManufactureTags = (response) => {
    try {
      const basic = this.state.basicDetails || {};
      const manufacturerName = basic.manufacturer;

      const result = get(response, 'result', response) || {};
      const manufacturerId = get(result, 'Manufacturer.id') || get(result, 'Manufacturer')?.id || null;
      const manufacturerObjFromResponse = get(result, 'Manufacturer') || null;

      let manufacturerObj =
        manufacturerObjFromResponse ||
        (manufacturerId ? (this.state.manufacturersList || []).find((m) => m.id === manufacturerId) : null) ||
        (this.state.manufacturersList || []).find((m) => m.name === manufacturerName) ||
        null;

      if (!manufacturerObj && manufacturerId) {
        manufacturerObj = { id: manufacturerId, name: manufacturerName || '', metadata: {} };
      }

      const backupDuringOutage = manufacturerObj?.metadata?.backupDuringOutage ?? null;
      const energyIndependence = manufacturerObj?.metadata?.energyIndependence ?? null;
      const savingsOnElectricityBill = manufacturerObj?.metadata?.savingsOnElectricityBill ?? null;

      const resolvedManufacturerId = manufacturerObj ? manufacturerObj.id : manufacturerId;

      const currentTags = this.state.manufacturerTags || {};
      const originalTags = this.state.tags || {};

      const manufChanged =
        !isEqual(currentTags.enfin || [], originalTags.enfin || []) ||
        !isEqual(currentTags.goodleap || [], originalTags.goodleap || []) ||
        !isEqual(currentTags.lightreach || [], originalTags.lightreach || []);

      if (manufChanged && this.props.updateManufactureTags && resolvedManufacturerId) {
        const outgoing = {
          manufacturer_enfin: this.normalizeOutgoingTags(currentTags.enfin || []),
          manufacturer_goodleap: this.normalizeOutgoingTags(currentTags.goodleap || []),
          manufacturer_lightreach: this.normalizeOutgoingTags(currentTags.lightreach || []),
        };

        const manufPayload = {
          manufacturerName,
          manufacturerId: resolvedManufacturerId,
          backupDuringOutage,
          energyIndependence,
          savingsOnElectricityBill,
          manufacturerTags: { ...outgoing },
        };

        this.props.updateManufactureTags(manufPayload);
      }
    } catch (err) {
      console.error('Error updating manufacturer-tags:', err);
    }
  };
  handleAddComment = (comment) => {
    this.setState({ comment: comment });
  };

  handleCommentDialogClose = () => {
    this.setState({ openCommentDialog: false, comment: '' });
  };

  handleCreateSuccessCallback = (newEquipment) => {
    this.handleGetSuccessCallback(newEquipment, () => {
      history.push('/equipment/dcpanel/' + get(newEquipment, 'id'));
    });
    scrollIntoView(document.getElementById('model'));
  };

  handleGetSuccessCallback = (equipment, callback = () => {}) => {
    const {
      id = 'new',
      video_url = '',
      spec_sheet = '',
      image_url = '',
      additional_document_url = '',
      spec_sheet_meta_data = {},
      prod_image_meta_data = {},
      spec_sheet_pages = '',
      created_at = '',
      verified_at = '',
      source_model_name,
      source_series_name,
      warranty = '',
      country_codes = [],
      comments = [],
      status = '',
      size_in_watts = '',
      ptc_in_watts = '',
      voc = '',
      vmp = '',
      isc = '',
      ipmax = '',
      efficiency = '',
      energy_degradation = '',
      voc_percent_to_celcius_ratio = '',
      voc_value_to_celcius_ratio = '',
      isc_percent_to_celcius_ratio = '',
      isc_value_to_celcius_ratio = '',
      tpmax_percent_to_celcius_ratio = '',
      tpmax_value_to_celcius_ratio = '',
      nominal_operating_cell_temperature = '',
      height = '',
      width = '',
      thickness = '',
      weight = '',
      cell_count = '',
      type = '',
      is_black_panel = false,
      num_submodules = null,
      submodule_partition = null,
      tags = {},
    } = equipment || {};

    const enl_catalog_user = isEmpty(equipment.enl_catalog_user)
      ? { created_by: '', updated_by: '', verified_by: '' }
      : equipment.enl_catalog_user;

    let voltage_temp_coefficient, current_temp_coefficient, voltage_temp_unit, current_temp_unit;
    if (!(voc_percent_to_celcius_ratio === null || voc_percent_to_celcius_ratio === '')) {
      voltage_temp_coefficient = voc_percent_to_celcius_ratio;
      voltage_temp_unit = '%/°C';
    } else {
      voltage_temp_coefficient = voc_value_to_celcius_ratio;
      voltage_temp_unit = 'V/°C';
    }
    if (!(isc_percent_to_celcius_ratio === null || isc_percent_to_celcius_ratio === '')) {
      current_temp_coefficient = isc_percent_to_celcius_ratio;
      current_temp_unit = '%/°C';
    } else {
      current_temp_coefficient = isc_value_to_celcius_ratio;
      current_temp_unit = 'A/°C';
    }
    let power_temp_coefficient, power_temp_unit;
    if (!(tpmax_percent_to_celcius_ratio === null || tpmax_percent_to_celcius_ratio === '')) {
      power_temp_coefficient = tpmax_percent_to_celcius_ratio;
      power_temp_unit = '%/°C';
    } else {
      power_temp_coefficient = tpmax_value_to_celcius_ratio;
      power_temp_unit = 'W/°C';
    }

    if (voltage_temp_coefficient === null) {
      voltage_temp_coefficient = '';
      voltage_temp_unit = '%/°C';
    }
    if (current_temp_coefficient === null) {
      current_temp_coefficient = '';
      current_temp_unit = '%/°C';
    }
    if (power_temp_coefficient === null) {
      power_temp_coefficient = '';
      power_temp_unit = '%/°C';
    }

    const incoming_enfin = this.normalizeIncomingTags(tags?.enfin || []);
    const incoming_goodleap = this.normalizeIncomingTags(tags?.goodleap || []);
    const incoming_lightreach = this.normalizeIncomingTags(tags?.lightreach || []);

    const manufMetaTags =
      (equipment &&
        equipment.Manufacturer &&
        equipment.Manufacturer.metadata &&
        equipment.Manufacturer.metadata.tags) ||
      {};

    const incoming_manufacturer_enfin = this.normalizeIncomingTags(manufMetaTags.enfin || []);
    const incoming_manufacturer_goodleap = this.normalizeIncomingTags(manufMetaTags.goodleap || []);
    const incoming_manufacturer_lightreach = this.normalizeIncomingTags(manufMetaTags.lightreach || []);

    this.setState(
      {
        id,
        basicDetails: {
          model: equipment.name,
          manufacturer: equipment?.Manufacturer?.name ? equipment['Manufacturer']['name'] : '',
          spec_sheet: !isEmpty(spec_sheet) ? [spec_sheet_meta_data] : [],
          prod_image: !isEmpty(image_url) ? [prod_image_meta_data] : [],
          additional_document: !isEmpty(additional_document_url) ? [{ url: additional_document_url }] : [],
          spec_sheet_pages,
          product_url: video_url,
          created_by: enl_catalog_user['created_by'],
          modified_by: enl_catalog_user['updated_by'],
          verified_by: enl_catalog_user['verified_by'],
          created_at,
          modified_at: equipment.updated_at,
          verified_at,
          source_model_name,
          source_series_name,
          warranty,
          country_codes,
          enfin_tags: incoming_enfin,
          goodleap_tags: incoming_goodleap,
          lightreach_tags: incoming_lightreach,
        },
        tags: {
          enfin: incoming_manufacturer_enfin,
          goodleap: incoming_manufacturer_goodleap,
          lightreach: incoming_manufacturer_lightreach,
        },
        manufacturerTags: {
          enfin: incoming_manufacturer_enfin,
          goodleap: incoming_manufacturer_goodleap,
          lightreach: incoming_manufacturer_lightreach,
        },
        electricalDetails: {
          max_power_rating_stc: size_in_watts,
          max_power_rating_ptc: ptc_in_watts,
          open_circuit_voltage: voc,
          max_power_voltage: vmp,
          short_circuit_current: isc,
          max_power_current: ipmax,
          efficiency,
          energy_degradation: round(Number(energy_degradation) * 100, 6),
          voltage_temp_coefficient: voltage_temp_coefficient.toString(),
          voltage_temp_unit: voltage_temp_unit,
          current_temp_coefficient: current_temp_coefficient.toString(),
          current_temp_unit: current_temp_unit,
          power_temp_coefficient: power_temp_coefficient.toString(),
          power_temp_unit,
          nominal_operating_cell_temperature,
        },
        physicalDetailsUnit: 'metric',
        physicalDetails: {
          width: Math.round(width * 100) / 100,
          length: Math.round(height * 100) / 100,
          thickness: Math.round(thickness * 100) / 100,
          weight: Math.round(weight * 100) / 100,
          cell_count,
          cell_type: type,
          black_on_black_panel: is_black_panel,
          num_submodules: num_submodules,
          submodule_partition: submodule_partition,
        },
        comments,
        currentStatus: status.toUpperCase(),
        readOnly: this.isReadOnly(),
      },
      () => {
        callback();
        if (!isEmpty(this.state.basicDetails.spec_sheet) && this.state.basicDetails.spec_sheet[0].page_count === null) {
          getFileMetaData(this.state.basicDetails['spec_sheet'][0], (meta_data) => {
            let basicDetails = {
              ...this.state.basicDetails,
              spec_sheet: [{ ...meta_data, material_id: this.state.id }],
            };
            this.setState({ ...this.state, basicDetails });
          });
        }
        if (!isEmpty(this.state.basicDetails.additional_document)) {
          getFileMetaData(this.state.basicDetails['additional_document'][0], (meta_data) => {
            const basicDetails = {
              ...this.state.basicDetails,
              additional_document: [{ ...meta_data, material_id: this.state.id }],
            };
            this.setState({ basicDetails });
          });
        }
      }
    );
  };

  // exposed handler for children to update manufacturer-level tags
  handleManufacturerTagsChange = (newManufacturerTags = {}) => {
    this.setState((prevState) => ({
      manufacturerTags: {
        ...prevState.manufacturerTags,
        ...newManufacturerTags,
      },
    }));
  };

  fileIcon = (fName) => {
    let fTypeArray = fName.split('.');
    let fType = fTypeArray[fTypeArray.length - 1].toLowerCase();
    if (fType === 'jpg') fType = 'jpeg';
    if (fType !== 'pdf' && fType !== 'png' && fType !== 'jpeg') {
      fType = 'document';
    }
    const DocIcon = Icons[fType];
    return <DocIcon />;
  };

  getPayload = (applicationStatus) => {
    const { id, comment, basicDetails, physicalDetailsUnit } = this.state;
    const manufacturerName = basicDetails.manufacturer;
    const manufacturerObject = this.state.manufacturersList.filter((val) => val['name'] === manufacturerName);
    if (isEqual(physicalDetailsUnit, 'imperial')) this.handleUnitConversion('getPayload');
    let file = null,
      image = null,
      additionalDocumentFileData = null,
      spec_sheet = {},
      prod_image = {},
      additional_document = {};

    if (!isEmpty(basicDetails['spec_sheet'])) {
      file = basicDetails['spec_sheet'][0]['fileData'];
      spec_sheet = basicDetails['spec_sheet'][0];
      delete spec_sheet['fileData'];
    }

    if (!isEmpty(basicDetails['prod_image'])) {
      image = basicDetails['prod_image'][0]['fileData'];
      prod_image = basicDetails['prod_image'][0];
      delete prod_image['fileData'];
    } else {
      if (this.props.equipment && !isEmpty(this.props.equipment['image_url']) && applicationStatus !== 'REJECTED') {
        const fileType = 'prodimage';
        const requestSource = 'dcpanel';
        this.props.deleteEquipmentUploadedFile({
          id,
          fileType,
          requestSource,
          successCb: () => {
            basicDetails['prod_image'] = [];
            this.setState({ basicDetails });
          },
        });
      }
    }
    if (!isEmpty(basicDetails['additional_document'])) {
      additionalDocumentFileData = basicDetails['additional_document'][0]['fileData'];
      additional_document = basicDetails['additional_document'][0];
      delete additional_document['fileData'];
    } else {
      if (
        this.props.equipment &&
        !isEmpty(this.props.equipment['additional_document_url']) &&
        applicationStatus !== 'REJECTED'
      ) {
        const fileType = 'additionaldocument';
        const requestSource = 'dcpanel';
        this.props.deleteEquipmentUploadedFile({
          id,
          fileType,
          requestSource,
          successCb: () => {
            basicDetails['additional_document'] = [];
            this.setState({ basicDetails });
          },
        });
      }
    }

    let voc_percent_to_celcius_ratio = '',
      voc_value_to_celcius_ratio = '',
      isc_percent_to_celcius_ratio = '',
      isc_value_to_celcius_ratio = '',
      tpmax_percent_to_celcius_ratio = '',
      tpmax_value_to_celcius_ratio = '';
    const {
      voltage_temp_coefficient = '',
      voltage_temp_unit = '',
      current_temp_coefficient = '',
      current_temp_unit = '',
      power_temp_coefficient = '',
      power_temp_unit = '',
    } = this.state.electricalDetails;
    if (isEqual(voltage_temp_unit, 'V/°C')) {
      voc_value_to_celcius_ratio = voltage_temp_coefficient;
      voc_percent_to_celcius_ratio = '';
    } else {
      voc_percent_to_celcius_ratio = voltage_temp_coefficient;
      voc_value_to_celcius_ratio = '';
    }
    if (isEqual(current_temp_unit, 'A/°C')) {
      isc_value_to_celcius_ratio = current_temp_coefficient;
      isc_percent_to_celcius_ratio = '';
    } else {
      isc_percent_to_celcius_ratio = current_temp_coefficient;
      isc_value_to_celcius_ratio = '';
    }
    if (isEqual(power_temp_unit, 'W/°C')) {
      tpmax_value_to_celcius_ratio = power_temp_coefficient;
      tpmax_percent_to_celcius_ratio = '';
    } else {
      tpmax_percent_to_celcius_ratio = power_temp_coefficient;
      tpmax_value_to_celcius_ratio = '';
    }

    /* in case of rejection we don't want to send anything other than comment and status.*/
    if (applicationStatus === 'REJECTED') {
      return {
        id,
        requestBody: {
          jsonPayload: {
            ...this.props.equipment,
            enl_catalog_user: null,
            status: applicationStatus,
            requestSource: 'dcpanel',
            comments: [{ status: applicationStatus, comment: comment }],
          },
        },
        successCB: (equipment, response) => {
          this.props.createEquipmentSuccess({ response });
          this.handleCreateSuccessCallback(equipment);
        },
        failureCB: (response) => {
          this.props.createEquipmentSuccess({ response });
        },
      };
    } else {
      const { width, length, thickness, weight } = this.state.physicalDetails;
      const basic = this.state.basicDetails || {};
      const enfin_tags = this.normalizeOutgoingTags(basic.enfin_tags || []);
      const goodleap_tags = this.normalizeOutgoingTags(basic.goodleap_tags || []);
      const lightreach_tags = this.normalizeOutgoingTags(basic.lightreach_tags || []);

      const manufacturer_enfin_tags = this.normalizeOutgoingTags(this.state.manufacturerTags.enfin || []);
      const manufacturer_goodleap_tags = this.normalizeOutgoingTags(this.state.manufacturerTags.goodleap || []);
      const manufacturer_lightreach_tags = this.normalizeOutgoingTags(this.state.manufacturerTags.lightreach || []);

      const snapshotManufacturerId =
        manufacturerObject.length === 1 && manufacturerObject[0].id ? manufacturerObject[0].id : null;
      const snapshotManufacturerName = manufacturerObject.length === 1 ? manufacturerObject[0].name : manufacturerName;

      const manufPayloadSnapshot = {
        manufacturerId: snapshotManufacturerId,
        manufacturerName: snapshotManufacturerName,
        manufacturerTags: {
          manufacturer_enfin: manufacturer_enfin_tags,
          manufacturer_goodleap: manufacturer_goodleap_tags,
          manufacturer_lightreach: manufacturer_lightreach_tags,
        },
        id: snapshotManufacturerId,
      };

      return {
        id,
        requestBody: {
          jsonPayload: {
            requestSource: 'dcpanel',
            model: this.state.basicDetails.model,
            Manufacturer: manufacturerObject.length === 1 ? manufacturerObject[0] : { name: manufacturerName },
            spec_sheet_meta_data: spec_sheet,
            prod_image_meta_data: prod_image,
            spec_sheet_pages: this.state.basicDetails.spec_sheet_pages,
            video_url: this.state.basicDetails.product_url,
            ...this.state.electricalDetails,
            energy_degradation: round(Number(this.state.electricalDetails.energy_degradation) / 100, 6),
            voc_percent_to_celcius_ratio: voc_percent_to_celcius_ratio,
            voc_value_to_celcius_ratio: voc_value_to_celcius_ratio,
            isc_percent_to_celcius_ratio: isc_percent_to_celcius_ratio,
            isc_value_to_celcius_ratio: isc_value_to_celcius_ratio,
            tpmax_percent_to_celcius_ratio,
            tpmax_value_to_celcius_ratio,
            ...this.state.physicalDetails,
            width: Math.round(width * 100) / 100,
            height: Math.round(length * 100) / 100,
            thickness: Math.round(thickness * 100) / 100,
            weight: Math.round(weight * 100) / 100,
            status: applicationStatus,
            comments: [{ status: applicationStatus, comment: comment }],
            warranty: this.state.basicDetails.warranty,
            country_codes: this.state.basicDetails.country_codes,
            tags: {
              enfin: enfin_tags,
              goodleap: goodleap_tags,
              lightreach: lightreach_tags,
            },
          },
          file: file,
          image: image,
          additionalDocument: additionalDocumentFileData,
        },
        successCB: (equipment, response = {}) => {
          this.props.createEquipmentSuccess({ response });
          this.handleCreateSuccessCallback(equipment);
        },
        failureCB: (response) => {
          this.props.createEquipmentSuccess({ response });
        },
        updateManufactureTags: () => {
          try {
            if (manufPayloadSnapshot.manufacturerId && this.props.updateManufactureTags) {
              this.props.updateManufactureTags(manufPayloadSnapshot);
            }
          } catch (err) {
            console.error('updateManufactureTags failed (fire-and-forget):', err);
          }
        },
      };
    }
  };

  validateFields = async (section, key = 'all') => {
    const {
      errorData,
      basicDetails,
      isEquipmentUnique,
      electricalDetails,
      physicalDetails,
      physicalDetailsUnit,
      isProductURLValid,
    } = this.state;
    const spec_sheet_pages = basicDetails.spec_sheet_pages;
    const specSheetPageCount = !isEmpty(basicDetails['spec_sheet'][0])
      ? basicDetails['spec_sheet'][0]['page_count']
      : 0;

    const omittedFields = [];
    // All basic details validations goes here
    if (section === 'basic_details' || section === 'all') {
      const basicDetailsRequiredFields = [
        'model',
        'manufacturer',
        'spec_sheet_pages',
        'product_url',
        'warranty',
        'country_codes',
      ];
      basicDetailsRequiredFields.forEach((ele) => {
        if (isEqual(ele, 'model') && isEmpty(basicDetails[ele])) errorData['model'] = 'Required';
        else if (isEqual(ele, 'manufacturer') && isEmpty(basicDetails[ele])) errorData[ele] = 'Required';
        else if (isEqual(ele, 'model') && !isEmpty(basicDetails['model']) && !isEquipmentUnique) {
          errorData['model'] = 'Model already exists';
        } else if (isEqual(ele, 'spec_sheet_pages') && isEmpty(basicDetails[ele])) errorData[ele] = 'Required';
        else if (
          isEqual(ele, 'spec_sheet_pages') &&
          !isEmpty(basicDetails[ele]) &&
          (isEqual(specSheetPageCount, undefined) || specSheetPageCount === 0)
        )
          errorData[ele] = 'Please upload a valid pdf document';
        else if (isEqual(ele, 'spec_sheet_pages') && !isEmpty(basicDetails[ele])) {
          if (!isEmpty(spec_sheet_pages)) {
            var error = false;
            var pages = spec_sheet_pages.split(',').map((item) => item.trim());
            pages.forEach((page) => {
              if (!isEmpty(page) && page > specSheetPageCount) {
                error = true;
                errorData[ele] = 'Page number cannot be greater than ' + specSheetPageCount;
              } else if (!isEmpty(page) && (isNaN(page) || page < 1 || page.includes('.'))) {
                error = true;
                errorData[ele] = 'Invalid input. Please enter positive integers only';
              }
            });
            if (spec_sheet_pages.slice(-1) === ',') {
              error = true;
              errorData[ele] = 'Invalid input';
            }
            if (!error) omittedFields.push(ele);
          }
        } else if (isEqual(ele, 'product_url') && !isEmpty(basicDetails[ele])) {
          var error = false;
          if (!isProductURLValid) {
            error = true;
            errorData[ele] = 'Invalid URL';
          } else if (!(basicDetails[ele].indexOf('http://') === 0 || basicDetails[ele].indexOf('https://') === 0)) {
            error = true;
            errorData[ele] = 'URL must start with http(s)://';
          }
          if (!error) omittedFields.push(ele);
        } else if (isEqual(ele, 'warranty') && !isEmpty(basicDetails[ele])) {
          var error = false;
          if (Number(basicDetails[ele]) < 0 || Number(basicDetails[ele]) > 50) {
            error = true;
            errorData[ele] = 'Value should be greater than or equal to 0 and less than or equal to 50';
          }
          if (!error) omittedFields.push(ele);
        } else if (isEqual(ele, 'country_codes') && isEmpty(basicDetails[ele])) {
          errorData[ele] = 'Required';
        } else omittedFields.push(ele);
      });
    }

    // All Electrical section validations goes here
    if (section === 'electrical_details' || section === 'all') {
      if (key === 'max_power_rating_stc' || section === 'all') {
        key = 'max_power_rating_stc';
        if (electricalDetails[key] === '') errorData[key] = 'Required';
        else if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) < 1 || Number(electricalDetails[key]) > 100000)
        )
          errorData[key] = 'Value should be between 1-100000';
        else omittedFields.push(key);
      }
      if (key === 'max_power_rating_ptc' || section === 'all') {
        key = 'max_power_rating_ptc';
        if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) < 0 || Number(electricalDetails[key]) > 100000)
        )
          errorData[key] = 'Value should be between 0-100000';
        else omittedFields.push(key);
      }
      if (key === 'open_circuit_voltage' || section === 'all') {
        key = 'open_circuit_voltage';
        if (electricalDetails[key] === '') errorData[key] = 'Required';
        else if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) <= 0 || Number(electricalDetails[key]) > 1000)
        )
          errorData[key] = 'Value should be greater than 0 and less than or equal to 1000';
        else omittedFields.push(key);
      }
      if (key === 'max_power_voltage' || section === 'all') {
        key = 'max_power_voltage';
        if (electricalDetails[key] === '') errorData[key] = 'Required';
        else if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) <= 0 || Number(electricalDetails[key]) > 1000)
        )
          errorData[key] = 'Value should be greater than 0 and less than or equal to 1000';
        else omittedFields.push(key);
      }
      if (key === 'short_circuit_current' || section === 'all') {
        key = 'short_circuit_current';
        if (electricalDetails[key] === '') errorData[key] = 'Required';
        else if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) <= 0 || Number(electricalDetails[key]) > 1000)
        )
          errorData[key] = 'Value should be greater than 0 and less than or equal to 1000';
        else omittedFields.push(key);
      }
      if (key === 'max_power_current' || section === 'all') {
        key = 'max_power_current';
        if (electricalDetails[key] === '') errorData[key] = 'Required';
        else if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) <= 0 || Number(electricalDetails[key]) > 1000)
        )
          errorData[key] = 'Value should be greater than 0 and less than or equal to 1000';
        else omittedFields.push(key);
      }
      if (key === 'efficiency' || section === 'all') {
        key = 'efficiency';
        if (electricalDetails[key] === '') errorData[key] = 'Required';
        else if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) < 0 || Number(electricalDetails[key]) > 40)
        )
          errorData[key] = 'Value should be between 0-40';
        else omittedFields.push(key);
      }
      if (key === 'energy_degradation' || section === 'all') {
        key = 'energy_degradation';
        if (electricalDetails[key] === '') errorData[key] = 'Required';
        else if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) < 0.01 || Number(electricalDetails[key]) > 100)
        )
          errorData[key] = 'Value should be between 0.01-100';
        else omittedFields.push(key);
      }
      if (key === 'voltage_temp_coefficient' || section === 'all') {
        key = 'voltage_temp_coefficient';
        if (electricalDetails[key] === '') errorData[key] = 'Required';
        else if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) < -1 || Number(electricalDetails[key]) >= 0)
        )
          errorData[key] = 'Value should be greater than or equal to -1 and less than 0';
        else omittedFields.push(key);
      }
      if (key === 'current_temp_coefficient' || section === 'all') {
        key = 'current_temp_coefficient';
        if (electricalDetails[key] === '') errorData[key] = 'Required';
        else if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) < -1 || Number(electricalDetails[key]) > 1)
        )
          errorData[key] = 'Value should be between -1 to 1';
        else omittedFields.push(key);
      }
      if (key === 'power_temp_coefficient' || section === 'all') {
        key = 'power_temp_coefficient';
        if (electricalDetails[key] === '') errorData[key] = 'Required';
        else if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) < -1 || Number(electricalDetails[key]) > 1)
        )
          errorData[key] = 'Value should be between -1 to 1';
        else omittedFields.push(key);
      }
      if (key === 'nominal_operating_cell_temperature' || section === 'all') {
        key = 'nominal_operating_cell_temperature';
        if (
          !isEmpty(electricalDetails[key]) &&
          (Number(electricalDetails[key]) < -273 || Number(electricalDetails[key]) > 1000)
        )
          errorData[key] = 'Value should be between -273 to 1000';
        else if (!isEmpty(electricalDetails[key]) && countDecimals(electricalDetails[key]) > 2)
          errorData[key] = 'Please enter upto 2 decimal places only';
        else omittedFields.push(key);
      }
    }

    // All Physical section validations goes here
    if (section === 'physical_details' || section === 'all') {
      var validateAll = false;
      if (key === 'all') validateAll = true;
      if (key === 'width' || section === 'all' || validateAll) {
        key = 'width';
        if (physicalDetails[key] === '') errorData[key] = 'Required';
        else if (
          physicalDetails[key] &&
          physicalDetailsUnit === 'imperial' &&
          (Number(physicalDetails[key]) < 1 || Number(physicalDetails[key]) > 500)
        )
          errorData[key] = 'Value should be between 1-500';
        else if (
          physicalDetails[key] &&
          physicalDetailsUnit === 'metric' &&
          (Number(physicalDetails[key]) < 1 || Number(physicalDetails[key]) > 12700)
        )
          errorData[key] = 'Value should be between 1-12700';
        else omittedFields.push(key);
      }
      if (key === 'length' || section === 'all' || validateAll) {
        key = 'length';
        if (physicalDetails[key] === '') errorData[key] = 'Required';
        else if (
          physicalDetails[key] &&
          physicalDetailsUnit === 'imperial' &&
          (Number(physicalDetails[key]) < 1 || Number(physicalDetails[key]) > 500)
        )
          errorData[key] = 'Value should be between 1-500';
        else if (
          physicalDetails[key] &&
          physicalDetailsUnit === 'metric' &&
          (Number(physicalDetails[key]) < 1 || Number(physicalDetails[key]) > 12700)
        )
          errorData[key] = 'Value should be between 1-12700';
        else omittedFields.push(key);
      }
      if (key === 'thickness' || section === 'all' || validateAll) {
        key = 'thickness';
        if (physicalDetails[key] === '') errorData[key] = 'Required';
        else if (
          physicalDetails[key] &&
          physicalDetailsUnit === 'imperial' &&
          (Number(physicalDetails[key]) <= 0 || Number(physicalDetails[key]) > 500)
        )
          errorData[key] = 'Value should be greater than 0 and less than or equal to 500';
        else if (
          physicalDetails[key] &&
          physicalDetailsUnit === 'metric' &&
          (Number(physicalDetails[key]) <= 0 || Number(physicalDetails[key]) > 12700)
        )
          errorData[key] = 'Value should be greater than 0 and less than or equal to 12700';
        else omittedFields.push(key);
      }
      if (key === 'weight' || section === 'all' || validateAll) {
        key = 'weight';
        if (physicalDetails[key] === '') errorData[key] = 'Required';
        else if (
          physicalDetails[key] &&
          physicalDetailsUnit === 'imperial' &&
          (Number(physicalDetails[key]) <= 0 || Number(physicalDetails[key]) > 2000)
        )
          errorData[key] = 'Value should be greater than 0 and less than or equal to 2000';
        else if (
          physicalDetails[key] &&
          physicalDetailsUnit === 'metric' &&
          (Number(physicalDetails[key]) <= 0 || Number(physicalDetails[key]) > 908)
        )
          errorData[key] = 'Value should be greater than 0 and less than or equal to 908';
        else omittedFields.push(key);
      }
      if (key === 'cell_count' || section === 'all') {
        key = 'cell_count';
        if (
          !isEmpty(physicalDetails[key]) &&
          (Number(physicalDetails[key]) <= 0 || Number(physicalDetails[key]) > 1000)
        )
          errorData[key] = 'Value should be greater than 0 and less than or equal to 1000';
        else omittedFields.push(key);
      }
    }

    const newErrorData = omit(errorData, omittedFields);
    return section === 'all' ? this.setState({ errorData: newErrorData }) : newErrorData;
  };

  handleCancel() {
    history.push('/equipment');
  }

  handleUnitConversion(calledFrom = '') {
    const { physicalDetailsUnit, physicalDetails } = this.state;
    const lbKeys = ['weight'];
    const inKeys = ['width', 'length', 'thickness'];
    const nonNumberKeys = ['cell_count', 'cell_type', 'num_submodules', 'submodule_partition', 'black_on_black_panel'];
    if (isEqual(physicalDetailsUnit, 'imperial') && calledFrom === '') {
      Object.entries(physicalDetails).forEach(([key, value]) => {
        if (lbKeys.includes(key) && value > 0) physicalDetails[key] = physicalDetails[key] / 0.454;
        else if (inKeys.includes(key) && value > 0) physicalDetails[key] = physicalDetails[key] / 25.4;
        if (!nonNumberKeys.includes(key)) physicalDetails[key] = Math.round(physicalDetails[key] * 100) / 100;
      });
    } else {
      Object.entries(physicalDetails).forEach(([key, value]) => {
        if (lbKeys.includes(key) && value > 0) physicalDetails[key] = physicalDetails[key] * 0.454;
        else if (inKeys.includes(key) && value > 0) physicalDetails[key] = physicalDetails[key] * 25.4;
        if (!nonNumberKeys.includes(key)) physicalDetails[key] = Math.round(physicalDetails[key] * 100) / 100;
      });
    }
    this.setState({ physicalDetails: physicalDetails });
  }

  handleModelValidation() {
    const { basicDetails, errorData, isEquipmentUnique } = this.state;
    if (!isEmpty(basicDetails['model']) && !isEquipmentUnique) errorData['model'] = 'Model already exists';
    else delete errorData['model'];
    this.setState({ errorData });
  }

  handleDuplicateModel = (e) => {
    const { basicDetails, manufacturersList } = this.state;
    const manufacturer = manufacturersList.filter((val) => val['name'] === basicDetails['manufacturer']);
    if (basicDetails['manufacturer'] && basicDetails['model']) {
      if (manufacturer.length !== 0) {
        const [modelName, manufacturerID, requestSource] = [e.target.value, manufacturer[0].id, 'panels'];
        this.props.getEquipmentModelValidation({
          modelName,
          manufacturerID,
          requestSource,
          successCb: () => {
            this.setState({ isEquipmentUnique: this.props.isEquipmentUnique }, () => {
              this.handleModelValidation();
            });
          },
        });
      } else {
        this.setState({ isEquipmentUnique: true }, () => {
          this.handleModelValidation();
        });
      }
    }
  };

  handleBasicDetails = async (e, key, value) => {
    const basicDetails = this.state.basicDetails;
    let errorData;
    if (isEqual(key, 'manufacturer')) {
      basicDetails[key] = value;

      const manufacturerObj = (this.state.manufacturersList || []).find((m) => m.name === value);
      const manufMetaTags = (manufacturerObj && manufacturerObj.metadata && manufacturerObj.metadata.tags) || {};
      const incoming_manufacturer_enfin = this.normalizeIncomingTags(manufMetaTags.enfin || []);
      const incoming_manufacturer_goodleap = this.normalizeIncomingTags(manufMetaTags.goodleap || []);
      const incoming_manufacturer_lightreach = this.normalizeIncomingTags(manufMetaTags.lightreach || []);

      this.setState({
        ...this.state,
        basicDetails,
        manufacturerTags: {
          enfin: incoming_manufacturer_enfin,
          goodleap: incoming_manufacturer_goodleap,
          lightreach: incoming_manufacturer_lightreach,
        },
        tags: {
          enfin: incoming_manufacturer_enfin,
          goodleap: incoming_manufacturer_goodleap,
          lightreach: incoming_manufacturer_lightreach,
        },
      });
      return;
    } else if (isEqual(key, 'spec_sheet_page_count')) {
      if (value !== null) {
        basicDetails.spec_sheet[0] = {
          ...this.state.basicDetails.spec_sheet[0],
          page_count: value,
        };
        this.setState({ ...this.state, basicDetails });
      }
    } else if (isEqual(key, 'country_codes')) {
      const fieldValue = e.target.value;
      basicDetails[key] = fieldValue;
      const inputLenth = fieldValue.length;
      const indexOfAll = fieldValue.indexOf('ALL');
      if (includes(fieldValue, 'ALL')) {
        basicDetails[key] = indexOfAll === inputLenth - 1 ? ['ALL'] : fieldValue.filter((item) => item !== 'ALL');
      }
    } else {
      basicDetails[key] = e.target.value;
      if (isEqual(key, 'model')) {
        this.setState({ ...this.state, basicDetails });
      }
      if (isEqual(key, 'product_url')) {
        this.setState({ isProductURLValid: validator.isURL(e.target.value) }, async () => {
          errorData = await this.validateFields('basic_details');
          this.setState({ ...this.state, basicDetails, errorData });
        });
        return;
      }
      if (key === 'created_by') {
        basicDetails['modified_by'] = e.target.value;
      }
    }
    this.setState({ basicDetails: basicDetails });
    errorData = await this.validateFields('basic_details');
    this.setState({ ...this.state, basicDetails, errorData });
  };

  handleElectricalDetails = async (e, key, value = '') => {
    const electricalDetails = this.state.electricalDetails;
    electricalDetails[key] = e.target.value;
    if (value) {
      electricalDetails[key] = value;
    }
    this.setState({ electricalDetails: electricalDetails });
    const errorData = await this.validateFields('electrical_details', key);
    this.setState({ ...this.state, electricalDetails, errorData });
  };

  handlePhysicalDetails = async (e, key) => {
    if (key) {
      const physicalDetails = this.state.physicalDetails;
      physicalDetails[key] = e.target.value;
      if (isEqual(key, 'black_on_black_panel')) {
        physicalDetails[key] = e.target.checked;
      }
      this.setState({ physicalDetails: physicalDetails });
      const errorData = await this.validateFields('physical_details', key);
      this.setState({
        ...this.state,
        physicalDetails,
        errorData,
      });
    } else {
      this.setState({ physicalDetailsUnit: e.target.value }, async () => {
        this.handleUnitConversion();
        const errorData = await this.validateFields('physical_details');
        this.setState({ errorData });
      });
    }
  };

  setDocumentUploadError(errorDetails = { error: false, msg: '' }, status, key = '') {
    let { fileUploadLogs } = this.state;
    fileUploadLogs[key].uploadError = {
      error: errorDetails.error,
      msg: errorDetails.msg,
    };
    if (status) {
      fileUploadLogs[key].uploadStatus = status;
    }
    this.setState({ fileUploadLogs: fileUploadLogs });
  }

  getFilePrefixName = (basicDetails) => {
    this.validateFields('basic_details');
    scrollIntoView(document.getElementById(keysIn(this.state.errorData)[0]));
    let filePrefixName = '';
    if (!isEmpty(basicDetails.model)) {
      filePrefixName = basicDetails.model;
    }
    if (!isEmpty(basicDetails.manufacturer)) {
      filePrefixName += '_' + basicDetails.manufacturer;
    }
    return filePrefixName;
  };

  deleteFile = (ind, key) => {
    // clear the message
    let { basicDetails, fileUploadLogs, errorData } = this.state;
    fileUploadLogs[key].uploadError = { error: false, msg: '' };
    this.setState({ fileUploadLogs: fileUploadLogs });

    if (isEqual(key, 'specSheet')) basicDetails['spec_sheet'] = [];
    else if (isEqual(key, 'additionalDocument')) {
      basicDetails['additional_document'] = [];
      delete errorData['additional_document'];
    } else basicDetails['prod_image'] = [];
    this.setState({ basicDetails, errorData });
  };

  handleFilesUpload = (event, key = '') => {
    // Clear error message
    this.setDocumentUploadError({ error: false, msg: '' }, '', key);

    let { fileUploadLogs } = this.state;
    let files = isEqual(key, 'specSheet')
      ? this.state.basicDetails.spec_sheet
      : isEqual(key, 'additionalDocument')
      ? this.state.basicDetails.additional_document
      : this.state.basicDetails.prod_image;

    const setStatus = (status) => {
      fileUploadLogs[key].uploadStatus = status;
      this.setState({ fileUploadLogs: fileUploadLogs });
    };

    const setFilesSize = (filesTotalSize) => {
      fileUploadLogs[key].size = filesTotalSize;
      this.setState({ fileUploadLogs: fileUploadLogs });
    };

    const details = {
      event,
      setStatus,
      setFilesSize,
      documentType: key,
      fileLocation: 'solargraf',
      namePrefix: this.getFilePrefixName(this.state.basicDetails),
      uploadFiles: files !== null ? files : [],
      uploadFilesSize: this.state.fileUploadLogs[key].size,
      maxFileUploadSize: this.MAX_ALLOWED_FILE_SIZE,
      setDocumentUploadError: (errorDetails, status) => this.setDocumentUploadError(errorDetails, status, key),
    };

    uploadFileDetails(details, (uploadFiles) => {
      const { basicDetails, errorData } = this.state;
      if (isEqual(key, 'specSheet')) basicDetails.spec_sheet = uploadFiles;
      else if (isEqual(key, 'additionalDocument')) {
        if (uploadFiles[0].fileData.type !== 'application/pdf') {
          errorData['additional_document'] = 'Please upload a valid pdf document';
        } else {
          delete errorData['additional_document'];
        }
        basicDetails.additional_document = uploadFiles;
      } else basicDetails.prod_image = uploadFiles;
      this.setState({ basicDetails, errorData });
    });
  };

  handleFileDownload = (key) => {
    // Clear error message
    this.setDocumentUploadError({ error: false, msg: '' }, '', key);
    let { id, fileUploadLogs, basicDetails } = this.state;
    if (id === 'new') {
      fileUploadLogs[key].uploadError = {
        error: true,
        msg: 'Unable to preview the file. Please try after some time.',
      };
      this.setState({
        fileUploadLogs: fileUploadLogs,
      });
    } else {
      const name = isEqual(key, 'specSheet')
        ? 'spec_sheet'
        : isEqual(key, 'additionalDocument')
        ? 'additional_document'
        : 'prod_image';
      if (basicDetails[name][0]['url']) {
        window.open(basicDetails[name][0]['url'], '_blank');
      } else {
        fileUploadLogs[key].uploadError = {
          error: true,
          msg: 'Unable to preview the file. Please try after some time.',
        };
        this.setState({
          fileUploadLogs: fileUploadLogs,
        });
      }
    }
  };

  // Available Permit service Roles => :application_user, :application_admin, :db_user, :db_admin, :db_view, :service_admin, :no_access
  isButtonVisible(buttonName) {
    const { readOnly } = this.state;
    const { permitServiceRole, equipment } = this.props;
    const current_status =
      equipment && !isEmpty(equipment.status) && this.props.match.params['id'] !== 'new'
        ? equipment.status.toUpperCase()
        : '';
    const currentStatusForDbAdmin =
      equipment && !isEmpty(equipment.status) && this.props.match.params['id'] !== 'new'
        ? equipment.status.toUpperCase()
        : this.props.match.params['id'] === 'new'
        ? 'new'
        : '';
    let isVisible = false;
    const dbWithApproved =
      includes(['APPROVED'], current_status) && includes(['db_admin', 'db_user'], permitServiceRole);
    const dbAdminWithPending =
      includes(['PENDING'], current_status) && includes(['db_admin', 'service_admin'], permitServiceRole);
    const dbAdminUserAccess =
      includes(['', 'APPROVED'], currentStatusForDbAdmin) && includes(['db_admin', 'db_user'], permitServiceRole);
    switch (buttonName) {
      case 'edit':
        isVisible = readOnly && !includes(VIEW_ONLY_ROLES, permitServiceRole) && !dbWithApproved && !dbAdminUserAccess;
        break;
      case 'approve':
      case 'reject':
        isVisible = includes(['PENDING'], current_status) && includes(['db_admin', 'service_admin'], permitServiceRole);
        break;
      case 'submit':
        isVisible =
          !dbAdminWithPending &&
          !dbWithApproved &&
          !readOnly &&
          !dbAdminUserAccess &&
          includes(['db_admin', 'db_user', 'service_admin'], permitServiceRole);
        break;
      case 'save':
        isVisible =
          includes([null, '', 'INCOMPLETE'], current_status) &&
          !dbAdminUserAccess &&
          includes(['db_admin', 'db_user', 'service_admin'], permitServiceRole);
        break;
      case 'outdated':
        isVisible = includes(['', 'APPROVED'], current_status) && includes(['service_admin'], permitServiceRole);
        break;
      default:
        break;
    }
    return isVisible;
  }

  isReadOnly() {
    //readonly is false for new Record
    if (this.props.match.params.id === 'new') return false;
    const { permitServiceRole, equipment } = this.props;
    const current_status = equipment && !isEmpty(equipment.status) ? equipment.status.toUpperCase() : '';
    return (
      (includes([''], current_status) && includes(['db_user', 'db_admin'], permitServiceRole)) ||
      (includes(['APPROVED', 'PENDING', 'OUTDATED'], current_status) &&
        includes(['db_user', 'db_admin', 'service_admin'], permitServiceRole))
    );
  }

  getErrorText = (fieldName) => {
    return this.state.recordSubmitted ? hasIn(this.state.errorData, fieldName) : false;
  };

  getHelperText = (fieldName) => {
    return this.state.recordSubmitted ? get(this.state.errorData, fieldName) : '';
  };

  render() {
    const { classes, currentlySending, messageType, message } = this.props;
    const {
      id,
      basicDetails,
      fileUploadLogs,
      manufacturersList,
      electricalDetails,
      physicalDetails,
      physicalDetailsUnit,
      currentStatus,
      comments,
      readOnly,
      manufacturerTags,
    } = this.state;
    const { name = '' } = basicDetails;
    const pageHeaderText = isEqual(id, 'new') ? 'Add new DC Panel' : name || 'DC Panel';
    return (
      <Box className={classes.root}>
        <Box className={classes.header}>
          <PageHeader text={pageHeaderText} />
          <CommentPopupBox comments={comments.map((ele) => ele['paComments'])} applicationStatus={currentStatus} />
        </Box>

        <BasicDetailsSection
          readOnly={readOnly}
          fileIcon={this.fileIcon}
          basicDetails={basicDetails}
          deleteFile={this.deleteFile}
          sectionLabel={'Basic Details'}
          fileUploadLogs={fileUploadLogs}
          errorData={this.state.errorData}
          manufacturersList={manufacturersList}
          handleFilesUpload={this.handleFilesUpload}
          handleFileDownload={this.handleFileDownload}
          handleBasicDetails={this.handleBasicDetails}
          handleDuplicateModel={this.handleDuplicateModel}
          type={'panel'}
          // pass manufacturer tags and handler
          manufacturerTags={manufacturerTags}
          handleManufacturerTagsChange={this.handleManufacturerTagsChange}
        />

        <ElectricalDetailsSection
          readOnly={readOnly}
          errorData={this.state.errorData}
          sectionLabel={'Electrical Details'}
          electricalDetails={electricalDetails}
          handleElectricalDetails={this.handleElectricalDetails}
        />

        <PhysicalDetailsSection
          readOnly={readOnly}
          unit={physicalDetailsUnit}
          errorData={this.state.errorData}
          physicalDetails={physicalDetails}
          sectionLabel={'Physical Details'}
          getErrorText={this.getErrorText}
          getHelperText={this.getHelperText}
          preventDefault={preventDefault}
          handlePhysicalDetails={this.handlePhysicalDetails}
        />

        {!includes([null, '', 'INCOMPLETE'], currentStatus) && <RecordDetailsSection recordDetails={basicDetails} />}

        <Box className={classes.actionButtons}>
          <Box>
            <Button id="companyCancel" variant="outlined" color="primary" onClick={() => this.handleCancel()}>
              {'Back'}
            </Button>
          </Box>
          <Box>
            {APPLICATION_STATE_TRANSITIONS.map(
              (transition) =>
                this.isButtonVisible(transition.key) && (
                  <Tooltip
                    key={'tooltip' + transition.key}
                    title="Any changes made by you will be lost"
                    arrow
                    disableHoverListener={transition.key !== 'reject'}
                    disableFocusListener={transition.key !== 'reject'}
                    disableTouchListener={transition.key !== 'reject'}
                    placement="top"
                  >
                    <Button
                      id={transition.key}
                      className={clsx(`${transition.key}Button`, classes.btnStyle)}
                      variant="contained"
                      color="primary"
                      onClick={() => this.handleSubmit(transition.value)}
                      key={transition.key}
                    >
                      {transition.title}
                    </Button>
                  </Tooltip>
                )
            )}
            <CommentDialog
              open={this.state.openCommentDialog}
              onClose={this.handleCommentDialogClose}
              dialogHeader={`${this.commentDialogHeader} Record`}
              secondaryHeaderText={
                this.event === 'OUTDATED'
                  ? MARK_AS_OUTDATED_HEADER
                  : `Do you want to ${this.commentDialogSecondaryHeader} this record?`
              }
              additionalSecondaryHeaderText={this.event === 'REJECTED' && REJECT_DIALOG_WARNING}
              handleProceed={this.handleProceed}
              setComment={(e) => this.handleAddComment(e)}
            />
          </Box>
        </Box>
        {(currentlySending ||
          this.state.fileUploadLogs.specSheet.uploadStatus !== 'idle' ||
          this.state.fileUploadLogs.prodImage.uploadStatus !== 'idle' ||
          this.state.fileUploadLogs.additionalDocument.uploadStatus !== 'idle') && (
          <Backdrop className={classes.backdrop} open>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        {!isEmpty(this.state.basicDetails.spec_sheet) &&
          (this.state.basicDetails.spec_sheet[0].page_count === null ||
            this.state.basicDetails.spec_sheet[0].file_size == null) && (
            <Backdrop className={classes.backdrop} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
        {message && messageType === 'success' && <SnakBar message={message} severity={messageType} />}
        {message && messageType === 'error' && <SnakBar message={message} severity={messageType} />}
      </Box>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getEquipment: (payload) => dispatch(getEquipment(payload)),
  createEquipment: (payload) => dispatch(createEquipment(payload)),
  getAllManufacturers: (payload) => dispatch(getAllManufacturers(payload)),
  createEquipmentSuccess: (payload) => dispatch(createEquipmentSuccess(payload)),
  getEquipmentModelValidation: (payload) => dispatch(getEquipmentModelValidation(payload)),
  deleteEquipmentUploadedFile: (payload) => dispatch(deleteEquipmentUploadedFile(payload)),
  updateManufactureTags: (payload) => dispatch(updateManufactureTags(payload)),
});

const mapStateToProps = (state) => ({
  message: state.equipmentReducer.message,
  equipment: state.equipmentReducer.equipment,
  messageType: state.equipmentReducer.messageType,
  currentlySending: state.equipmentReducer.currentlySending,
  manufacturersList: state.equipmentReducer.manufacturersList,
  isEquipmentUnique: state.equipmentReducer.isEquipmentUnique,
  permitServiceRole: state.appReducer.permitServiceRole,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(index));
